export const DEFAULT_PAGINATION_PARAMS = {
  start: 0,
  limit: 10,
  maxNumLoadable: 100,
};
